import { PlateRenderElementProps, setNodes, useEditorRef } from '@udecode/plate';
import router from 'next/router';
import * as React from 'react';
import { ReactEditor } from 'slate-react';
import { API } from 'src/api';
import { FileType } from 'src/features/files/types/file';
import { useAuth } from 'src/shared/hooks/use-auth';

import { FileButton } from './file-button';
import { FilePopup } from './file-popup';

const { useCallback, useEffect, useState } = React;

export type FileElementProps = PlateRenderElementProps & {
  element: {
    fileId?: string;
    fileTitle?: string;
    fileIcon?: string;
  };
};

export const FileElement = (props: FileElementProps) => {
  const { attributes, children, element } = props;
  const editor = useEditorRef();
  const { fileId, fileTitle } = element;
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;
  const [fileData, setFileData] = useState<Partial<FileType>>({});
  const isPublicFile = useAuth((s) => s.isPublicFile);
  const fileLink = `/${mode}/${orgId}/files/${fileId}${isPublicFile ? '/public' : ''}`;

  const onSetFile = useCallback(
    (fileId: string, fileTitle: string, fileIcon: any) => {
      const path = ReactEditor.findPath(editor, element);
      setNodes(editor, { fileId, fileTitle, fileIcon }, { at: path });
    },
    [editor]
  );

  const fetchFile = useCallback(async () => {
    try {
      const response = await API.get(`files?id=${fileId}`);
      if (response.data.success) {
        // update file data to the slate node
        const { file } = response.data.data;
        file && setFileData(file);
        const title = file.title;
        const icon = file?.icon;
        onSetFile(fileId!, title, icon);
      }
    } catch (error) {
      console.error(error);
    }
  }, [fileId]);

  const fetchPublicFile = useCallback(async () => {
    try {
      const response = await API.get(`files/public?id=${fileId}`);
      if (response.data.success) {
        // update file data to the slate node
        const { file } = response.data.data;
        file && setFileData(file);
        // const title = file.title;
        // const icon = file?.icon;
        // onSetFile(fileId!, title, icon);
      }
    } catch (error) {
      console.error(error);
    }
  }, [fileId]);

  useEffect(() => {
    if (fileId) {
      if (!isPublicFile) fetchFile();
      else fetchPublicFile();
    }
  }, [fileId, isPublicFile]);

  return (
    <div {...attributes}>
      {fileId ? (
        <FileButton
          filename={fileTitle}
          file={fileData}
          fileLink={fileLink}
          isPublicDoc={isPublicFile}
        />
      ) : !isPublicFile ? (
        <FilePopup
          onSubmit={(id, title, icon) => {
            onSetFile(id, title, icon);
          }}
        />
      ) : (
        <div />
      )}
      {children}
    </div>
  );
};
